"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _GumballParameterApi_parameter;
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGumballParameterApi = exports.GumballParameterApi = void 0;
const ParameterApi_1 = require("./ParameterApi");
class GumballParameterApi extends ParameterApi_1.ParameterApi {
    // #endregion Properties (1)
    // #region Constructors (1)
    constructor(parameter) {
        super(parameter);
        // #region Properties (1)
        _GumballParameterApi_parameter.set(this, void 0);
        __classPrivateFieldSet(this, _GumballParameterApi_parameter, parameter, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (9)
    get enableRotation() {
        return __classPrivateFieldGet(this, _GumballParameterApi_parameter, "f").enableRotation;
    }
    get enableScaling() {
        return __classPrivateFieldGet(this, _GumballParameterApi_parameter, "f").enableScaling;
    }
    get enableTranslation() {
        return __classPrivateFieldGet(this, _GumballParameterApi_parameter, "f").enableTranslation;
    }
    get hover() {
        return __classPrivateFieldGet(this, _GumballParameterApi_parameter, "f").hover;
    }
    get interactionType() {
        return __classPrivateFieldGet(this, _GumballParameterApi_parameter, "f").interactionType;
    }
    get nameFilter() {
        return __classPrivateFieldGet(this, _GumballParameterApi_parameter, "f").nameFilter;
    }
    get scale() {
        return __classPrivateFieldGet(this, _GumballParameterApi_parameter, "f").scale;
    }
    get selectionColor() {
        return __classPrivateFieldGet(this, _GumballParameterApi_parameter, "f").selectionColor;
    }
    get space() {
        return __classPrivateFieldGet(this, _GumballParameterApi_parameter, "f").space;
    }
}
exports.GumballParameterApi = GumballParameterApi;
_GumballParameterApi_parameter = new WeakMap();
const isGumballParameterApi = (obj) => obj instanceof GumballParameterApi;
exports.isGumballParameterApi = isGumballParameterApi;
//# sourceMappingURL=GumballParameterApi.js.map